var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="suppress-lead-card">\n  <div class="suppress-lead-card-body">\n    <p class="suppress-lead-card-text">To inquire about this listing, please call \n      <a href="tel:(855) 228-5301">(855) 228-5301</a>\n    </p>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-suppress-lead-placeholder.jst.ejs